/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Prints(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 5C10.75 4.30964 11.3096 3.75 12 3.75C12.6904 3.75 13.25 4.30964 13.25 5C13.25 5.69036 12.6904 6.25 12 6.25C11.3096 6.25 10.75 5.69036 10.75 5ZM12 2.25C10.652 2.25 9.53047 3.21994 9.29534 4.5H1V6H9.43747C9.66154 6.57377 10.0728 7.05383 10.5961 7.36514L11.5526 11H12.5L13.4096 7.36177C13.9302 7.05037 14.3393 6.57171 14.5625 6H23V4.5H14.7047C14.4695 3.21994 13.348 2.25 12 2.25ZM3.75 9V20.25H11.25V17.75L6 17.75V16.25L12 16.25H18V17.75H12.75V20.25H20.25V9H21.75V21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V9H3.75Z"
        fill="currentColor"
      />
    </svg>
  )
}

Prints.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Prints
